export default {"src":"/_next/static/media/copy-outlined.91f5d54e.svg","height":28,"width":28};